import React from "react";
import IconButton from "../../../_components/IconButton"
import TableData from "../../../_components/TableData";
import { getBarcodes, getIMG } from "../../../api/barcodes";
import CreateFilterModal from "./createFilterModal";
import Button from "../../../_components/Button";
import CreateBarcodeModal from "./createBarcodeModal";
import { donwloadBase64 } from "../../../utils";
import Text from "../../../_components/Text";
import { checkIfBranchExists } from "../../../utils";
import CreateWarningModal from "./createWarningModal";

export default function testeRender() {
    checkIfBranchExists()
    const [barcodeList, setBarcodeList] = React.useState([])
    const [showModal, setShowModal] = React.useState(false)
    const [showWarningModal, setShowWarningModal] = React.useState(false)
    const [showFilterModal, setShowFilterModal] = React.useState(false)
    const [downloadPNG, setDownloadPNG] = React.useState(false)
    const [printPNG, setPrintPNG] = React.useState(false)
    const [fullList, setFullList] = React.useState([])
    const defaultEndCount = {
        end_count: 10
    }
    function getBarcodesList(params) {
        getBarcodes(params)
            .then((barcodes) => {
                    setBarcodeList(barcodes.map(item => {
                    return {
                        ...item,
                        actions: (<span>
                                    <IconButton disabled={downloadPNG}
                                        onClick={() => {onDownload(item.id)}}
                                        icon={downloadPNG ? "spinner fa-pulse" : "download" } 
                                        title="baixar PNG" />
                                    <IconButton disabled={printPNG}
                                        onClick={() => {onPrint(item.id)}}
                                        icon={printPNG ? "spinner fa-pulse" : "print" }
                                        title="Imprimir imagem" />
                                </span>)
                            }       
                        }
                    )      
                )
            }
        )
    }

    function getFullBarcodeList() {
        let params = {
            end_count: null
        }
        getBarcodes(params).then((barcodes) => {
            setFullList(barcodes.map(item=>{
                return {
                    ...item
                }
            }))
        })
    }

    function onDownload(id) {
        setDownloadPNG(!false)
        getIMG(id).then(data => {
            donwloadBase64(id, ".png", "image/png", data.base64)
        }
        ).finally(() => {
            setDownloadPNG(false)
        })
    }
    
    function onPrint(id) {
        setPrintPNG(!false)
        getIMG(id).then(data => {
            let win = window.open();
            win.document.write('<img src="data:image/png;base64,'
                                + data.base64 +
                                '" onload="window.print();window.close()" />');
            win.focus();
        }).finally(() => {
            setPrintPNG(false)
        })
    }

    function init() {
        getBarcodesList(defaultEndCount)
        setShowWarningModal(true)
    }
    React.useEffect(() => {
        init()
    },[])
    return (
        <div className="text-center">
            <div className="my-3">
                <div className="d-flex justify-content-center align-items-center">
                    <Text fontSize="lg" className="me-2">Código de barras</Text>
                    <IconButton
                    icon="exclamation-triangle fa-1x"
                    onClick={() => setShowWarningModal(true)}/>
                </div>
    
        <div className="center">
                <Button onClick={() => 
                    {setShowModal(true)
                    getFullBarcodeList()}}>
                    Criar
                </Button>
        </div>
        <Button className="d-flex"
                title = "filtrar códigos"
                onClick={() => setShowFilterModal(true)}
        >
            <i className="fas fa-filter"/>
        </Button>
        </div>



            {
                <TableData
                    tHead={["Código", "Tipo", "Produto", "Descrição", "Ações"]}
                    tBodyKeys={["code", "provided_barcode", "product_name", "description", "actions"]}
                    data={barcodeList}
                />

            }


            {
                <CreateBarcodeModal
                    show={showModal}
                    onHide={() => {

                        setShowModal(false)
                    }}
                    onSave={(data) => {
                        getBarcodesList()
                    }}
                    barcodeList = {fullList}
                />
            }

            {
                <CreateWarningModal
                show={showWarningModal}
                    onHide={() => {

                        setShowWarningModal(false)
                    }}/>
            }

            {
                <CreateFilterModal
                    show={showFilterModal}
                    onHide={() => {
                        setShowFilterModal(false)
                    }}
                    onSave={(product_id, end_count, provided_barcode) => {
                        
                        let params = {
                            product_id: product_id,
                            provided_barcode: provided_barcode,
                            end_count: end_count
                        }
                        getBarcodesList(params)
                    }}
                    onClear={() => {
                        getBarcodesList(defaultEndCount)
                    }}
                    />
                
            }

        </div>
    )
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Barcodes/index.jsx